import React from "react";
import Select, { Option } from "rc-select";
import MemberBanksCon from "./../../../Components/Common/MemberBanks";
import Input from "./../Input";

import translate from "./../../../lib/translate/TranslateJs";

function MemberBanks(props) {
    return (
        <MemberBanksCon
            {...props}
            // 充值金额提示信息标签
            Select={(propCon) => {
                return (
                    <Select
                        showSearch={false}
                        value={propCon.currValue}
                        optionLabelProp="children"
                        onChange={propCon.onSelectChange}
                    >
                        {propCon.memberBankList.map((v, i) => (
                            <Option
                                className={`${
                                    v.type === "push" ? "light-blue" : ""
                                }`}
                                key={i}
                                value={v[propCon.valueKey]}
                            >
                                <>
                                    {v.type === "push" ? (
                                        <>
                                            <p>{v.name}</p>
                                            <div
                                                className="addIcon"
                                            />
                                        </>
                                    ) : (
                                        <>
                                            <div
                                                className={`bankIcon-default bankIcon-${v.imgName}`}
                                            />
                                            <p>{v[propCon.maskName]}</p>
                                        </>
                                    )}
                                </>
                            </Option>
                        ))}
                    </Select>
                );
            }}
            AddBankButton={(propCon) => {
                return (
                    <div
                        className="addBankcard"
                        onClick={propCon.goAddBankInfo}
                    >
                        {translate("添加银行卡")()}
                    </div>
                );
            }}
        />
    );
}

export default MemberBanks;
